import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'
import { parse } from 'query-string'

import { loadSignup } from '../../modules/signup/actions'
import { selectSignupByReference } from '../../modules/signup/selectors'
import { makeSelectLoadingOrError } from '../../modules/loading'

export default function* handleView({ payload }) {
  const hash = yield effects.call(parse, payload.location.hash)
  if (hash.accessKey) {
    yield effects.put.resolve(pushPath(payload.location.pathname))
  }

  const state = yield effects.select()
  const signup = yield effects.call(
    selectSignupByReference,
    state.signup,
    payload.reference,
  )

  if (signup) {
    return
  }

  const selector = yield effects.call(makeSelectLoadingOrError)
  const loading = yield effects.call(selector, state, {
    key: payload.reference,
    type: 'signup',
  })

  if (!loading) {
    yield effects.put.resolve(loadSignup(payload.reference, hash.accessKey))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/signup/handleView.js